var _g, _path, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOfflineLicensing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1060,
    height: 90,
    viewBox: "14 9 1060 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3260_695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.187 17C14.187 12.5817 17.7687 9 22.187 9H1065.49C1069.91 9 1073.49 12.5817 1073.49 17V90.7937C1073.49 95.212 1069.91 98.7937 1065.49 98.7937H22.187C17.7688 98.7937 14.187 95.212 14.187 90.7937V17Z",
    fill: "#440E70"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3260_695",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 1060,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.187 9.5H1069.49C1071.42 9.5 1072.99 11.067 1072.99 13V94.7939C1072.99 96.7268 1071.42 98.2939 1069.49 98.2939H18.187C16.2541 98.2939 14.6871 96.7268 14.687 94.7939V13C14.687 11.067 16.254 9.5 18.187 9.5Z",
    fill: "#4A3AFF",
    stroke: "#EFF0F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3260_695)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M767.465 9.26918C765.256 9.26918 763.427 11.0782 763.881 13.2403C764.639 16.854 766.43 20.4012 769.209 23.771C773.001 28.3687 778.559 32.5462 785.566 36.0651C792.572 39.584 800.89 42.3753 810.045 44.2797C819.199 46.1841 829.011 47.1643 838.92 47.1643C848.829 47.1643 858.641 46.1841 867.795 44.2797C876.95 42.3753 885.268 39.584 892.275 36.0651C899.281 32.5462 904.839 28.3687 908.631 23.771C911.41 20.4011 913.201 16.854 913.959 13.2402C914.413 11.0782 912.584 9.26917 910.375 9.26917L838.92 9.26918L767.465 9.26918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M780.784 61.8682C782.993 61.8682 784.818 63.6725 784.429 65.8471C783.628 70.3196 781.481 74.7133 778.048 78.8762C773.601 84.2684 767.082 89.1679 758.865 93.2949C750.647 97.4219 740.892 100.696 730.155 102.929C719.418 105.163 707.911 106.312 696.29 106.312C684.668 106.312 673.161 105.163 662.424 102.929C651.687 100.696 641.932 97.4219 633.714 93.2949C625.497 89.1679 618.979 84.2684 614.531 78.8762C611.098 74.7133 608.951 70.3196 608.15 65.8471C607.761 63.6725 609.586 61.8682 611.795 61.8682L696.29 61.8682L780.784 61.8682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 914.354,
    y: 26.9592,
    width: 76.0606,
    height: 151.45,
    rx: 4,
    transform: "rotate(90 914.354 26.9592)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M772.433 154.794C768.192 154.794 766.866 149.061 770.677 147.2L839.912 113.38L908.431 77.8938C911.094 76.5149 914.271 78.4474 914.271 81.4458L914.271 150.794C914.271 153.003 912.48 154.794 910.271 154.794L772.433 154.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.07,
    cx: 993.759,
    cy: 79.1895,
    rx: 25.3494,
    ry: 79.2874,
    transform: "rotate(90 993.759 79.1895)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.491 18.7937C14.491 13.2708 18.9689 8.78166 24.4903 8.90745C39.5466 9.25047 54.3548 10.3665 68.3404 12.2191C85.4127 14.4806 100.925 17.7953 113.992 21.9739C127.058 26.1525 137.423 31.1133 144.495 36.573C151.566 42.0326 155.206 47.8842 155.206 53.7937C155.206 59.7032 151.566 65.5548 144.495 71.0145C137.423 76.4741 127.058 81.4349 113.992 85.6135C100.925 89.7921 85.4127 93.1068 68.3403 95.3683C54.3547 97.2209 39.5466 98.3369 24.4902 98.6799C18.9688 98.8057 14.4909 94.3165 14.4909 88.7937L14.491 53.7937L14.491 18.7937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 1073.49,
    y: 3.25488,
    width: 50.8797,
    height: 159.143,
    rx: 4,
    transform: "rotate(90 1073.49 3.25488)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1028.47 9C1033.05 9 1034.03 15.4583 1029.66 16.8196L979.989 32.264L919.627 52.1651C917.039 53.0182 914.374 51.0909 914.374 48.3662L914.374 13C914.374 10.7908 916.165 8.99999 918.374 8.99999L1028.47 9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3260_695",
    x: 0.187012,
    y: 0,
    width: 1087.3,
    height: 117.794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0323264 0 0 0 0 0.0598209 0 0 0 0 0.204167 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3260_695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3260_695",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineLicensing);
export default __webpack_public_path__ + "static/media/offline_licensing.67c81fdfbe92709589774b7951ee9c2e.svg";
export { ForwardRef as ReactComponent };